import { Api } from '@axiom/ui';
import type {
  Candidate,
  Experience,
  GroupedExperiences,
} from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class CandidateExperienceApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiPortalUrl,
    });
  }

  readExperiences(candidateId: Candidate['id']) {
    return super.read<{ data: Experience[] }>({
      endpoint: `/candidates/${candidateId}/experiences`,
      method: 'GET',
    });
  }

  readGroupedExperiences(candidateId: string) {
    return super.read<{ data: GroupedExperiences[] }>({
      endpoint: `/candidates/${candidateId}/groupedExperiences`,
      method: 'GET',
    });
  }

  async refreshExperiences(candidateId: string) {
    return super.invalidate(`/candidates/${candidateId}/experiences`);
  }

  async refreshGroupedExperiences(candidateId: string) {
    return super.invalidate(`/candidates/${candidateId}/groupedExperiences`);
  }
}

export const CandidateExperienceApi = new CandidateExperienceApiClass();
